export const JWT_CLAIMS = {
	POK_ID: 'http://globalpoker.com/pok_id',
	CUBEIA_ID: 'http://globalpoker.com/cubeia_id',
	SCREEN_NAME: 'http://globalpoker.com/screen_name',
	STATE: 'http://globalpoker.com/state',
	REGISTRATION_DATE: 'http://globalpoker.com/registration_date',
	VIEWER_COUNTRY: 'http://globalpoker.com/viewer_country',
	VIEWER_COUNTRY_REGION: 'http://globalpoker.com/viewer_country_region',
	PAGE_LOAD_API_CLICK_ID: 'http://globalpoker.com/pageLoadApiClickId',
} as const
